export default {
  bootstrap: {
    bg: {
      colors: [
        'primary',
        'secondary',
        'success',
        'danger',
        'warning',
        'info',
        'dark'
      ]
    }
  }
}
